import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { BUILDING_GROUP_ACTION_REMOVE_GROUP_FIELD_NAME_REMOVE_MANAGERS } from '../../BuildingGroupActions'

import { ITEM_ACTION_TYPES } from './useBuildingGroupTableActions.constants'

export function getItemActionTypes(availableTypes = ITEM_ACTION_TYPES) {
  return Object.values(getEntityActionTypeSelectOptions()).filter(item =>
    availableTypes.includes(item.value)
  )
}

export function getBuildingGroupDeleteFromGroupPayload({
  buildingGroupIds,
  values,
}) {
  return {
    building_groups: buildingGroupIds,
    update_responsible_users:
      values[BUILDING_GROUP_ACTION_REMOVE_GROUP_FIELD_NAME_REMOVE_MANAGERS],
  }
}
